import React, { useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { FaArrowLeft, FaLock, FaShoppingBag } from "react-icons/fa";

import API_BASE_URL from "../config/api";

import "./CustomerDetails.css";

function CustomerDetails() {
  const location = useLocation();
  const navigate = useNavigate();

  /*
    
    SUPPORT BOTH FLOWS

    1. BUY NOW
       state = {
         product,
         quantity
       }

    2. CART
       state = {
         cartItems
       }
    
  */

  const { product, quantity = 1, cartItems } = location.state || {};

  /*
    Convert both flows into one common products array.
  */

  const orderItems =
    cartItems && cartItems.length > 0
      ? cartItems
      : product
      ? [
          {
            ...product,
            quantity,
          },
        ]
      : [];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    postalCode: "",
    country: "Pakistan",
    notes: "",
  });

  /*
    
    IF NOTHING WAS PASSED
    
  */

  if (orderItems.length === 0) {
    return (
      <div className="tv-customer-error">
        <h2>Order not found</h2>

        <button onClick={() => navigate("/shop")}>
          BACK TO SHOP
        </button>
      </div>
    );
  }

  /*
    
    PRICE CALCULATION
    
  */

  const deliveryCharges = 299;

  const subtotal = orderItems.reduce((total, item) => {
    const price = Number(item.price) || 0;
    const itemQuantity = Number(item.quantity) || 1;

    return total + price * itemQuantity;
  }, 0);

  const total = subtotal + deliveryCharges;

  /*
    
    INPUT CHANGE
    
  */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /*
    
    SUBMIT
    
  */

  const handleSubmit = (e) => {
    e.preventDefault();

    navigate("/payment-method", {
      state: {
        /*
          Keep single product data as well
          so existing BUY NOW flow remains compatible.
        */
        product:
          orderItems.length === 1
            ? orderItems[0]
            : null,

        quantity:
          orderItems.length === 1
            ? Number(orderItems[0].quantity) || 1
            : 1,

        /*
          New multi-product data
        */
        cartItems: orderItems,

        customer: formData,

        subtotal,
        deliveryCharges,
        total,
      },
    });
  };

  /*
    
    IMAGE URL
    
  */

  const imageUrl = (image) => {
    if (!image) return "";

    if (image.startsWith("http")) {
      return image;
    }

    return `${API_BASE_URL}/${image.replace(/^\/+/, "")}`;
  };

  return (
    <main className="tv-customer-page">
      <div className="tv-customer-container">

        {/* BACK */}

        <button
          className="tv-customer-back"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
          BACK TO PRODUCT
        </button>

        {/* HEADER */}

        <div className="tv-customer-header">
          <span>TIME VALLEY</span>

          <h1>
            Complete Your
            <em> Order.</em>
          </h1>

          <p>
            Please provide your details below to complete your purchase.
          </p>
        </div>

        <div className="tv-customer-layout">

          {/* =================================================
              FORM
          ================================================= */}

          <form
            className="tv-customer-form"
            onSubmit={handleSubmit}
          >

            {/* CUSTOMER DETAILS */}

            <div className="tv-form-section">

              <div className="tv-form-title">
                <span>01</span>

                <div>
                  <h2>Customer Details</h2>
                  <p>Your personal information</p>
                </div>
              </div>

              <div className="tv-form-grid">

                <div className="tv-field tv-field-full">

                  <label>FULL NAME *</label>

                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                  />

                </div>

                <div className="tv-field">

                  <label>EMAIL ADDRESS *</label>

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="you@example.com"
                    required
                  />

                </div>

                <div className="tv-field">

                  <label>PHONE NUMBER *</label>

                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+92 300 1234567"
                    required
                  />

                </div>

              </div>

            </div>

            {/* =================================================
                ADDRESS
            ================================================= */}

            <div className="tv-form-section">

              <div className="tv-form-title">

                <span>02</span>

                <div>
                  <h2>Delivery Address</h2>
                  <p>Where should we deliver your order?</p>
                </div>

              </div>

              <div className="tv-form-grid">

                <div className="tv-field tv-field-full">

                  <label>COMPLETE ADDRESS *</label>

                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="House / Flat No, Street, Area..."
                    rows="4"
                    required
                  />

                </div>

                <div className="tv-field">

                  <label>CITY *</label>

                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="Your city"
                    required
                  />

                </div>

                <div className="tv-field">

                  <label>POSTAL CODE</label>

                  <input
                    type="text"
                    name="postalCode"
                    value={formData.postalCode}
                    onChange={handleChange}
                    placeholder="Postal code"
                  />

                </div>

                <div className="tv-field tv-field-full">

                  <label>COUNTRY *</label>

                  <input
                    type="text"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                  />

                </div>

              </div>

            </div>

            {/* =================================================
                NOTES
            ================================================= */}

            <div className="tv-form-section">

              <div className="tv-form-title">

                <span>03</span>

                <div>
                  <h2>Order Notes</h2>
                  <p>Anything we should know?</p>
                </div>

              </div>

              <div className="tv-field">

                <label>ADDITIONAL NOTES</label>

                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Optional delivery instructions..."
                  rows="4"
                />

              </div>

            </div>

            {/* CONTINUE */}

            <button
              type="submit"
              className="tv-place-order"
            >
              <FaShoppingBag />
              CONTINUE TO PAYMENT
            </button>

            <div className="tv-secure-note">
              <FaLock />
              Your information is securely handled.
            </div>

          </form>

          {/* =================================================
              ORDER SUMMARY
          ================================================= */}

          <aside className="tv-order-summary">

            <div className="tv-summary-heading">

              <span>YOUR ORDER</span>

              <h2>Order Summary</h2>

            </div>

            {/* =================================================
                ALL PRODUCTS
            ================================================= */}

            {orderItems.map((item) => (

              <div
                className="tv-summary-product"
                key={item.id}
              >

                <div className="tv-summary-image">

                  <img
                    src={imageUrl(item.image1)}
                    alt={item.name}
                  />

                </div>

                <div className="tv-summary-product-info">

                  <span>TIME VALLEY</span>

                  <h3>{item.name}</h3>

                  <p>
                    Quantity: {item.quantity || 1}
                  </p>

                  <strong>
                    Rs.{" "}
                  {(
  Number(item.price || 0) *
  Number(item.quantity || 1)
).toLocaleString()}
                  </strong>

                </div>

              </div>

            ))}

            {/* DIVIDER */}

            <div className="tv-summary-line"></div>

            {/* SUBTOTAL */}

            <div className="tv-summary-row">

              <span>Subtotal</span>

              <strong>
                Rs. {subtotal.toLocaleString()}
              </strong>

            </div>

            {/* TOTAL ITEMS */}

            <div className="tv-summary-row">

              <span>Total Items</span>

              <strong>
                {orderItems.reduce(
                  (count, item) =>
                    count + Number(item.quantity || 1),
                  0
                )}
              </strong>

            </div>

            {/* DELIVERY */}

            <div className="tv-summary-row">

              <span>Delivery</span>

              <strong>
               Rs. {deliveryCharges.toLocaleString()}
              </strong>

            </div>

            {/* TOTAL */}

            <div className="tv-summary-total">

              <span>Total</span>

              <strong>
                Rs. {total.toLocaleString()}
              </strong>

            </div>

            <div className="tv-summary-bottom">
              Delivery charges of Rs. 299 included.
            </div>

          </aside>

        </div>
      </div>
    </main>
  );
}

export default CustomerDetails;